import { Button, message, Table, Tag } from "antd";
import { ColumnsType, TablePaginationConfig } from 'antd/lib/table';
import { FC, useEffect, useState } from "react";
import { notification } from 'antd';
import moment from "moment-jalaali";
import Actions from "../actions";
import { useNavigate } from "react-router-dom";
import restful from "../../restful";

interface DataType {
    name: String
    ordername: String
    roile: String
    _id: String
    createdAt: Date
    updatedAt: Date
    status: string
    count: number,
    yasStatus: any
}

interface Params { page?: number; perPage?: number, sortDir: string, sort: string }

const OrdersTable: FC<{ filters: any }> = ({ filters }) => {
    const navigate = useNavigate()
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [items, setItems] = useState<DataType[]>([]);
    const [pagination, setPagination] = useState<TablePaginationConfig>({
        current: 1,
        pageSize: 10,
    });

    const onResetClick = (id: string) => {
        restful.post('/orders/' + id + '/reset')
            .then((res) => {
                fetchData({ sortDir: "desc", sort: "updatedAt", page: pagination.current, perPage: pagination.pageSize })
            })
            .catch((err) => message.error(err.message));
    }

    const columns: ColumnsType<DataType> = [
        {
            sorter: true, title: 'موبایل', dataIndex: 'user', key: 'mobile', width: 120,
            render(val) { return val?.mobile }
        },
        {
            sorter: true, title: 'کاربر', dataIndex: 'user', key: 'name',
            render(val) { return val?.name }
        },

        {
            sorter: true, title: 'محصول', dataIndex: 'product', key: 'product',
            render(val) { return val?.title }
        },
        {
            sorter: false, title: 'باقی مانده', dataIndex: 'count', key: 'count', width: 120,
            render(val, row) { return parseInt(row.yasStatus?.remains || val).toLocaleString() + " از " + val.toLocaleString() }
        },
        {
            sorter: true, title: 'مبلغ', dataIndex: 'cost', key: 'cost', width: 100,
            render(val) { return val.toLocaleString() }
        },
        { sorter: true, title: 'لینک', dataIndex: 'link', key: 'link' },
        { sorter: true, title: 'کد پیگیری', dataIndex: 'trackingCode', key: 'trackingCode', width: 120, },
        {
            sorter: true, title: 'وضعیت', dataIndex: 'status', key: 'status', width: 100,
            render(val) {
                if (val === "new") return <Tag color="yellow">جدید</Tag>;
                if (val === "awaiting") return <Tag color="red">انتظار پرداخت</Tag>;
                if (val === "paid") return <Tag color="yellow">پرداخت شده</Tag>;
                if (val === "doing") return <Tag color="yellow">در حال انجام</Tag>;
                if (val === "done") return <Tag color="green">انجام شده</Tag>;
                if (val === "error") return <Tag color="red">خطا</Tag>;
                return val
            }
        },
        // {
        //     defaultSortOrder: 'descend',
        //     sorter: true, title: 'زمان ایجاد', dataIndex: 'createdAt', key: 'createdAt', width: 110,
        //     render(val) {
        //         return moment(val).format('jYYYY/jMM/jDD H:mm:ss')
        //     },
        // },
        {
            defaultSortOrder: 'descend',
            sorter: true, title: 'بروزرسانی', dataIndex: 'updatedAt', key: 'updatedAt', width: 170,
            render(val) {
                return moment(val).format('jYYYY/jMM/jDD H:mm:ss')
            },
        },
        {
            title: 'عملیات', dataIndex: '_id', key: '_id', width: 100,
            render(val, data) {
                return <Button onClick={() => onResetClick(val)} disabled={data.status !== 'awaiting'}>ریست</Button>
            }
        },

    ];

    const fetchData = (params: Params) => {
        setIsLoaded(true);
        restful.get(`/orders/paginate`, { params: { ...params, ...filters } })
            .then((res) => {
                const result = res.data.result
                setItems(result.orders);
                setPagination({
                    current: params.page,
                    pageSize: params.perPage,
                    total: result.ordersCount,
                })
            })
            .catch((error) => {
                return notification.error({
                    message: 'Error ' + error.statusCode,
                    description: error.message,
                });
            })
            .finally(() => { setIsLoaded(false) })
    };

    useEffect(() => {
        fetchData({ sortDir: "desc", sort: "updatedAt", page: pagination.current, perPage: pagination.pageSize });
    }, [filters])

    const handleTableChange = (newPagination: TablePaginationConfig, filter: any, sorter: any) => {
        if (pagination.pageSize !== newPagination.pageSize) newPagination.current = 1
        fetchData({
            page: newPagination.current,
            perPage: newPagination.pageSize,
            sortDir: sorter.order === "ascend" ? "asc" : "desc",
            sort: sorter.field ?? "updatedAt"
        });
    };

    return <Table
        columns={columns}
        dataSource={items}
        loading={isLoaded}
        rowKey="_id"
        pagination={pagination}
        onChange={handleTableChange}
    />
}

export default OrdersTable


